import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueIntro from '../node_modules/vue-introjs/dist/index.min.js'

import App from './App'
import router from './router'

import('../node_modules/vuetify/dist/vuetify.min.css')
import('../node_modules/intro.js/introjs.css')

Vue.use(VueIntro)
Vue.use(Vuetify)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

/*
Strategio-over-loaded: Debe tener una configuración inicial configurable para poder generar:
  * NORMAL: Visualizador + favoritos + tutorial
  * GLOBAL: NORMAL + ACCESO A TODOS LOS REPORTES
  * SUPERVISOR: GLOBAL + Modulo de supervision de datos
  * ADMIN: SUPERVISOR + Herramientas administrativas
  * DEMO: GLOBAL + aviso de versión de prueba + login automático - logout - Opciones de usuario(cerrar sesión y cambiar password, nombre y cargo)

Nucleos principales:
  - folder-list
  - folder-list-item
  - report-list
  - report-list-item (add to favorite)
  - report-list-item-show (add to favorite)
  - report-list-item-show-list
  - favorite-list
  - favorite-item
  - user-login(switch: auto)
  - strategio-header(includes openPanel(), logo, tutorial)

Núcleos administrativos:
  - folder-list-options
  - folder-list-item-options
  - report-list-options
  - report-list-item-options
  - user-options:
    NORMAL and GLOBAL: panel, show: Mi cuenta, tutorial, cerrar sesion
    ADMIN: (NORMAL and GLOBAL) + administrar*
    * administrar: admin user config, reports meta-data, reports access, enable/disable users, change user type

Tutorial:
  1. Grabs the first folder with a report inside (from caché) and start the tutorial
*/



// WEBPACK FOOTER //
// ./src/main.js